
import React from 'react';
import PropTypes from 'prop-types';

import { useAnnotation } from '../../../hooks';
import { TOOLS_IDS } from '../../../utils/constants';
import AnnotationOptions from '../../../components/common/AnnotationOptions';

const StarOptions = ({ t }) => {
  const [star, saveStar] = useAnnotation({
    name: TOOLS_IDS.STAR,
  });

  return (
    <AnnotationOptions
      className="respark_star-tool-options"
      annotation={star}
      updateAnnotation={saveStar}
      t={t}
      hidePositionField
    />
  );
};

StarOptions.propTypes = {
  t: PropTypes.func.isRequired,
};

export default StarOptions;
